import { useState } from "react";
import { simpleGetter } from "../../actions/common";
import { clubsApi } from "../../api/api";
import Delete from "../../assets/icons/Delete";
import Edit from "../../assets/icons/Edit";
import Eye from "../../assets/icons/Eye";
import { ManyUsers } from "../../assets/icons/ManyUsers";
import NoEye from "../../assets/icons/NoEye";
import { showSnackbar } from "../../misc/utils";
import { accessGlobalMiscState } from "../../stores/misc";
import { Club } from "../../types";
import { Avatar } from "../Avatar";
import { HasRole } from "../HasRole";
import DefaultButton from "../default-button/DefaultButton";

type TableItemPropsType = {
  item: Club;
  index: number;
};

const TableItem = ({ item, index }: TableItemPropsType) => {
  const [expanded, setExpanded] = useState(false);

  const clubAdmin = item.members.find((m) => m.club_members.is_admin);

  const editClub = () => {
    accessGlobalMiscState().setBatch({
      clubFormMode: "edit",
      clubFormVisible: true,
      clubFormEditItem: item,
    });
  };

  const deleteClub = async () => {
    const response = await simpleGetter(clubsApi.deleteClub, { id: item.id });
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      accessGlobalMiscState().set(
        "allClubsTriggerFetch",
        (accessGlobalMiscState().get("allClubsTriggerFetch") || 0) + 1
      );
    }
  };

  const showUsers = () => {
    accessGlobalMiscState().setBatch({
      clubMembersShow: true,
      clubMembersShowItem: item,
    });
  };

  return (
    <tr key={index} className='border-b border-gray-200 bg-white-500'>
      <td className='px-4 py-2 bg-white font-semibold max-w-[120px] leading-5 text-black'>
        {item.name}
      </td>

      <td className='px-4 py-3 border-b max-w-[310px] min-w-[260px]'>
        <div className='max-w-full text-gray-500 leading-5 font-normal'>
          <p
            className={`block transition-all duration-200 ${
              expanded ? "" : "line-clamp-4"
            }`}
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {item.description}
          </p>

          {item.description?.length > 120 && (
            <button
              onClick={() => setExpanded(!expanded)}
              className='text-blue-500 text-sm font-medium mt-1'
            >
              {expanded ? "Свернуть" : "Развернуть"}
            </button>
          )}
        </div>
      </td>

      <td className='px-4 py-2 bg-white min-w-[190px] max-w-[210px]'>
        <div className='flex items-center gap-3'>
          {clubAdmin && <Avatar user={clubAdmin} />}
          <div className='flex flex-col leading-5'>
            <span className='font-semibold text-black'>
              {`${clubAdmin?.json_saved_data.lastname || ""} ${
                clubAdmin?.json_saved_data.firstname || ""
              }`}
            </span>
            <span className='text-sm text-gray-500'>
              {clubAdmin?.json_saved_data.email}
            </span>
          </div>
        </div>
      </td>

      <td className='px-4 py-2 bg-white max-w-[50px] text-black'>
        {item.category.name}
      </td>

      <td className='px-4 py-2 bg-white'>
        <div className='flex flex-col items-center'>
          <button
            className='flex flex-col items-center px-2 py-1 gap-1 bg-valley-main rounded-lg'
            disabled={!item.members.length}
            onClick={showUsers}
          >
            <ManyUsers color='#FFFFFF' />
            <span className='text-sm text-white font-medium'>
              {item.members.filter((m) => m.club_members.status === 2).length}
            </span>
          </button>
        </div>
      </td>

      <td className='px-4 py-2 bg-white max-w-[120px]'>
        {item.status ? (
          <button className='flex items-center gap-1 text-blue-500 font-semibold text-[16px]'>
            <Eye />
            Видимый
          </button>
        ) : (
          <button className='flex items-center gap-1 text-gray-500 font-semibold text-[16px]'>
            <NoEye />
            Заблокирован
          </button>
        )}
      </td>

      <td className='px-4 py-2 bg-white w-[80px]'>
        <HasRole roles={["create_clubs"]}>
          <div className='flex gap-3 items-center'>
            <DefaultButton
              onClick={editClub}
              Icon={Edit}
              additionalStyle='bg-gray-100 text-gray-500 border-gray-300 px-2 hover:bg-gray-200'
            />
            <DefaultButton
              onClick={deleteClub}
              Icon={Delete}
              additionalStyle='bg-red-50 text-red-500 border-red-300 px-2 hover:bg-red-100'
            />
          </div>
        </HasRole>
      </td>
    </tr>
  );
};

export default TableItem;
